import React, { useEffect } from "react";
import moment from "moment";
import { useRecepcionTraslado } from "../hooks/useRecepcionTraslado";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ProductosTable } from "./ProductosTable";
import { useForm } from "react-hook-form";
import { NumberField } from "../../../../../Utils/renderField/fieldsHookForms";
import { usePesajeBascula } from "../../../../../Utils/APIs/usePesajeBascula";
import Alerta from "../../../../../Utils/Alerta/Alerta";
import CardEmpty from "Utils/Cards/CardEmpty";
import { getVehiculoLabel } from "../../../helpers/data";

export const IngresoForm = (props) => {
    const { traslado_id, regresar, navigateToDetail, configuraciones, user } =
        props;

    const { pesoManual, pesoBascula } = usePesajeBascula({
        configuraciones,
        user,
    });

    const {
        control,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const { trasladoDetalle, CrearRecepcionTraslado, cargando } =
        useRecepcionTraslado(
            traslado_id,
            navigateToDetail,
            validateForm,
            formGetValues,
        );

    useEffect(() => {
        if (!pesoManual && pesoBascula) {
            formSetValue("peso_bruto", pesoBascula, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        } else if (!pesoManual && !pesoBascula) {
            formSetValue("peso_bruto", "", {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        }
    }, [pesoBascula]);

    return (
        <LoadMask loading={cargando} blur>
            <form>
                <div className="form-group grid-container">
                    <div className="form-group grid-container d-flex align-items-center flex-column">
                        <div className="col-12 col-lg-9">
                            <div className="d-flex mb-4 align-items-center">
                                <h6>
                                    DATOS GENERALES DE RECEPCIÓN POR TRASLADO
                                </h6>
                                <h4 className="ml-3">
                                    {trasladoDetalle.numero}
                                </h4>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap align-items-end">
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label htmlFor="fecha" className="m-0">
                                            FECHA
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <input
                                            type="date"
                                            name="fecha"
                                            className="form-control"
                                            value={
                                                trasladoDetalle.fecha_recepcion
                                                    ? moment(
                                                          trasladoDetalle.fecha_recepcion,
                                                      ).format("YYYY-MM-DD")
                                                    : ""
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label
                                            htmlFor="hora_ingreso"
                                            className="m-0"
                                        >
                                            HORA
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <input
                                            type="time"
                                            name="hora_ingreso"
                                            className="form-control"
                                            value={
                                                trasladoDetalle.fecha_recepcion
                                                    ? moment(
                                                          trasladoDetalle.fecha_recepcion,
                                                      ).format("HH:mm")
                                                    : ""
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap align-items-end">
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label
                                            htmlFor="vehiculo"
                                            className="m-0"
                                        >
                                            VEHÍCULO
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <input
                                            type="text"
                                            name="vehiculo"
                                            className="form-control"
                                            value={getVehiculoLabel(
                                                trasladoDetalle.vehiculo,
                                            )}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label htmlFor="piloto" className="m-0">
                                            PILOTO
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <input
                                            type="text"
                                            name="piloto"
                                            className="form-control"
                                            value={
                                                trasladoDetalle.piloto
                                                    ? `${trasladoDetalle.piloto.nombre}`
                                                    : ""
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap align-items-end">
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label
                                            htmlFor="tipo_materia"
                                            className="m-0"
                                        >
                                            TIPO DE MATERIA PRIMA
                                        </label>
                                    </div>
                                    <div className="col-md-12 form-group">
                                        <input
                                            type="text"
                                            name="tipo_materia"
                                            className="form-control"
                                            value={
                                                trasladoDetalle.detalles &&
                                                trasladoDetalle.detalles
                                                    .length > 0
                                                    ? trasladoDetalle
                                                          .detalles[0]
                                                          .materia_prima &&
                                                      trasladoDetalle
                                                          .detalles[0]
                                                          .materia_prima
                                                          .tipo_materia_prima &&
                                                      trasladoDetalle
                                                          .detalles[0]
                                                          .materia_prima
                                                          .tipo_materia_prima
                                                          .nombre
                                                    : ""
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label htmlFor="finca" className="m-0">
                                            FINCA
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        {trasladoDetalle.acopio_origen &&
                                        trasladoDetalle.acopio_origen
                                            .finca_asociada ? (
                                            <input
                                                type="text"
                                                name="finca"
                                                className="form-control"
                                                value={
                                                    trasladoDetalle
                                                        .acopio_origen
                                                        .finca_asociada.nombre
                                                }
                                                disabled
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                name="finca"
                                                className="form-control"
                                                style={{
                                                    color: "red",
                                                    fontWeight: "bold",
                                                }}
                                                value={
                                                    cargando
                                                        ? ""
                                                        : "EL ACOPIO DE ORIGEN NO TIENE FINCA ASOCIADA"
                                                }
                                                disabled
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap align-items-start">
                                <div className="col-md-6 form-group p-0">
                                    <CardEmpty noShadow noPadding>
                                        <div className="col-12 pt-2">
                                            <label
                                                htmlFor="peso_bruto"
                                                className="m-0"
                                            >
                                                PESO BRUTO DE INGRESO
                                            </label>
                                        </div>
                                        <div className="col-md-12 form-group">
                                            <NumberField
                                                control={control}
                                                name="peso_bruto"
                                                errors={errors}
                                                allowNegative={false}
                                                suffix=" Kg"
                                                rules={{
                                                    required:
                                                        "Este campo es obligatorio",
                                                    min: {
                                                        value: 1,
                                                        message:
                                                            "Debe ser al menos 1",
                                                    },
                                                }}
                                                disabled={!pesoManual}
                                            />
                                        </div>
                                    </CardEmpty>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-md-12 form-group d-flex align-content-center justify-content-center">
                                        <Alerta
                                            texto={
                                                pesoManual
                                                    ? `El peso se está tomando manualmente. Para tomarlo de báscula vaya a Configuración.`
                                                    : `El peso se está tomando automaticamente de Báscula. Para ingresarlo manualmente se debe ir a Configuración.`
                                            }
                                            noMarginBottom
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TABLA DE PRODUCTOS */}
                    <ProductosTable trasladoDetalle={trasladoDetalle} />

                    <div className="buttons-box mt-5">
                        <button
                            type="button"
                            className="btn btn-outline-dark mr-5"
                            onClick={regresar}
                        >
                            CANCELAR
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={CrearRecepcionTraslado}
                        >
                            CONFIRMAR RECEPCIÓN
                        </button>
                    </div>
                </div>
            </form>
        </LoadMask>
    );
};
